import { SxProps, TextField, TextFieldProps, useMediaQuery } from "@mui/material";
import theme from "../../theme/theme";

type RubiosTextFieldProps = {
  rubiosVariant?: 'desktop' | 'mobile';
} & TextFieldProps;

export default function (props: RubiosTextFieldProps) {
  let { rubiosVariant, ...otherProps } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!rubiosVariant) {
    rubiosVariant = isMobile ? 'mobile' : 'desktop'
  }

  let sx: SxProps = {};
  if (rubiosVariant === 'desktop') {
    sx = {
      "& .MuiInputLabel-root": {
        color: "#052C42 !important" // Set your desired color for the label
      },
      "& .MuiInputBase-root": {
        backgroundColor: 'white',
        boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 6%), 0px 4px 5px 0px rgb(0 0 0 / 6%), 0px 1px 10px 0px rgb(0 0 0 / 6%) !important',
      },

      "& fieldset": { border: 'unset !important' },

      "& .MuiFormLabel-filled,& .MuiInputLabel-shrink"
        : { top: "14px", fontSize: '12px' },
      // "& .MuiInputLabel-formControl"
      //   : { lineHeight: '1.1rem !importnat' }
    };
  } else if (rubiosVariant === 'mobile') {
    sx = {
      // 
      "& .MuiInputLabel-root": {
        color: "#052C42" // Set your desired color for the label
      },
      "& .MuiInputBase-root": {
        backgroundColor: 'white',
        boxShadow: 'none !important'
      },

      "& fieldset": { border: 'auto !important', borderRadius: '10px' },

      "& .MuiFormLabel-filled,& .MuiInputLabel-shrink"
        : { top: "auto", fontSize: 'auto' },
    }
  }


  // Spread remaining props and custom styles to the Textfield component
  return <TextField {...otherProps} sx={{
    ...sx,
    ...props.sx || {} as any
  }}
  />;
};
